module.exports = __webpack_public_path__ + "assets/img/grid-cc1a7965.png";